import React, { useEffect, useRef, useState } from 'react'
import back from '../../assests/images/back_pg.png'
import flag from '../../assests/images/flag.svg'
import profile from '../../assests/images/profile_2.png'
import diamond from '../../assests/images/diamond.svg'
import Cross from '../../assests/images/cross.svg'
import M from 'materialize-css';
import nodata from '../../assests/images/podium.svg'
import { Link } from 'react-router-dom'
import { useContext } from 'react';
import { DataContext } from '../../context/DataContext';
import { Leader } from "../../utils/Api";
import Loader from '../../assests/images/loader.gif'
import { useQuery, useQueryClient } from "@tanstack/react-query";
import Footer from '../footer/Footer'
const Leaderboard = () => {
    const { data: contextData, loading, error, refetch, setAndroidId, androidId } = useContext(DataContext);
    const [scrolled, setScrolled] = useState(false);
    const modelRef = useRef(null);
    // function formatContent(content) {
    //     const cleanedContent = content.replace(/[^a-zA-Z0-9 @. ]/g, "");
    //     return cleanedContent.length > 10 ? cleanedContent.slice(0, 10) : cleanedContent;
    // }
    // const queryClient = useQueryClient();
    // const { data, loading, error, refetch } = useContext(DataContext);
    // const { data: leaderboarddata, isLoading: isUserLoading, error: userError } = useQuery({
    //     queryKey: ["Leaderboard", data ? data.user_id : '', data ? data.idtoken : ''],
    //     queryFn: () => Leader({
    //         user_id: data ? data.user_id : '',
    //         idtoken: data ? data.idtoken : '',
    //     }),
    // });
    // useEffect(() => {
    //     const elems = document.querySelectorAll('.modal');
    //     M.Modal.init(elems, {
    //         opacity: 0.8,
    //     });
    // }, []);
    //   useEffect(() => {
    //     const handleScroll = () => {
    //       setScrolled(window.pageYOffset > 0);
    //     };

    //     window.addEventListener('scroll', handleScroll);

    //     // Cleanup on unmount
    //     return () => {
    //       window.removeEventListener('scroll', handleScroll);
    //     };
    //   }, []);
    const { data, isLoading, isError } = useQuery({
        queryKey: ['leaderboard'],
        queryFn: async () => await Leader({ user_id: contextData.user_id }),
        enabled: !!contextData?.user_id
    })


    useEffect(() => {
        if (modelRef.current) {
            const modalInstance = M.Modal.init(modelRef.current, {
            });
            return () => {
                modalInstance.destroy();
            };
        }
    }, []);

    if (isLoading || loading) return <div className="body_area22">
        <div className="cointainr loader">
            <img src={Loader}></img>
        </div></div>; if (isError) return <p>Error: {error.message}</p>;


    return (
        <div>
            <div className="header navbar-fixed">
                <nav className={scrolled ? 'scrolled top_nav' : 'top_nav'}>
                    <div className="h_left">
                        <Link to={-1} className="btn_tp icon_sq">
                            <img src={back} alt="back_pg" />
                        </Link>
                        Leaderboard
                    </div>
                    <div className="h_right">
                        <button data-target='modal' className="modal-trigger btn_tp whitee">
                            How to win?
                        </button>
                    </div>
                </nav>
            </div>


            <div className="body_area22">
                <div className="cointainr">



                    <div className="flex_gap top_head">
                        <div className="d_flx2 gap">
                            <p>Rank</p>
                            <p>Username</p>
                        </div>
                        <p>Winning Amount</p>
                    </div>

                    <div className="column_area mt_none">
                        <div className="Tasks_rem">


                            {/* your Rank*/}
                            {data?.result && data?.result?.map((ele, idx) => {
                                return (
                                    <>
                                        <div className={`taks_item ${ele.is_user == 1 ? 'your_rank' : ''}`}>
                                            <div className="d_flex roww">
                                                <h1 className="task_count brdr_none">{ele.rank}</h1>
                                                <div className="d_flx2 mb_none gap">
                                                    <img src={profile} alt="profile" className="ldr_img" />
                                                    {ele.is_user == 1 ? (
                                                        <h2 className="ttl_sm">You</h2>
                                                    ) : (
                                                        <h2 className="ttl_sm">{ele.user_name}</h2>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="win_daim btn_tp">
                                                <img src={diamond} alt="diamond" />
                                                {ele.total_diamonds}
                                            </div>
                                        </div>
                                    </>
                                )
                            })}

                            {data && data.result.length === 0 && (
                                <div className='err_msg msg_sm'>
                                    <img src={nodata} alt='nodata' className="profile_sq" />
                                    <p className="desc12">Leaderboard will be created on 1st day of next month.</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <Footer></Footer>
                </div>
            </div>
            <div id="modal" class="modal bottom-sheet modal_text" ref={modelRef}>
                <div class="d_flx2">
                    <h2 class="main_ttl">How to<p>Win</p></h2>
                    <a class="modal-close">
                        <img src={Cross} alt="cross" class="flt_50" />
                    </a>
                </div>

                <ul class="mt_10">
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                </ul>
            </div>


        </div>
    )
}
export default Leaderboard
